// extracted by mini-css-extract-plugin
export default {"content":"XEbcU","pill":"Plbr2","pillButton":"GWpZ0"};